import { render, staticRenderFns } from "./ProgramInfo.vue?vue&type=template&id=26746684&scoped=true"
import script from "./ProgramInfo.vue?vue&type=script&lang=js"
export * from "./ProgramInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26746684",
  null
  
)

export default component.exports